import React, { useEffect, useState } from "react";
import NextImage from "./NextImage";
import CountdownTimer from "./CountdownTimer";
import { convertDate, extractScores, getMatchImageUrl, Icon, teamLeagueInfoUrl } from "../../utils/generalLiveCenter";
import { useMatchSocket } from "../../hooks/useMatchSocket";


const CricketMatchDetailHead = ({
  data,
  sport = "cricket",
  websiteBaseUrl,
  dataPath,
  dataClient,
  dictionary = {},
  show_cricket_animation, socketUrl,
  channel,
  event,
}) => {
  const baseURL =
    process.env.REACT_APP_BASE_URL ??
    "https://ipublisher-microservices.6lgx.com";
  const [match, setMatch] = useState(data);
  const scores = [];

  const imageUrl = getMatchImageUrl(
    sport,
    match?.competitors?.[sport === "tennis" ? "hpid" : "htid"]
  );
  const awayImage = getMatchImageUrl(
    sport,
    match?.competitors?.[sport === "tennis" ? "apid" : "atid"]
  );

  if (sport === "basketball") {
    for (let i = 1; i <= 4; i++) {
      scores.push(extractScores(match, i));
    }
  }
  useMatchSocket({ socketUrl, channel, event, sport, setMatch });

  useEffect(() => {
    setMatch(data);
  }, [data]);


  return (
    <div className="cricket_detail_head">
      <div className="detail_head_top">
        <span
          className={`${match?.bs === "Live" ? "stats_tag red" : "stats_tag"}`}
        >
          {dictionary?.[match?.bs?.toLowerCase()] || match?.bs}
        </span>

        <h1>

          <a
            href={teamLeagueInfoUrl({
              dataClient,
              websiteBaseUrl,
              dataPath,
              category: "league",
              sport,
              name: match?.tournament?.nm,
              id: match?.tournament?.id,
            })}
          >
            <span className="icon_flag">
              <NextImage
                src={`${baseURL}/assets/images/flags/country_${match?.tournament?.football_category?.fid ||
                  match?.tournament?.fid
                  }.png`}
                alt="flag"
                width={22}
                height={22}
                priority={false}
              />
            </span>

            <div className="name_wrp">
              <span className="name">{match?.tournament?.nm}</span>
              <span className="sub_info_mtch">{match?.mno}</span>
            </div>
          </a>
          {/* </NextLink> */}
        </h1>
      </div>
      {show_cricket_animation === 1 ? (
        <iframe
          className="ifrmae-widget"
          src={`https://widgets.thesports01.com/en/cricket?profile=8nq2kc475czulqy&uuid=${match?.aimId}`}
          bis_size='{"x":459,"y":249,"w":746,"h":520,"abs_x":459,"abs_y":249}'
          title="Cricket Match Animation"
        ></iframe>
      ) : null}
      <div className="detail_head_bdy">
        <div className="detail_bdy_inner">
          <ul className="team_info">
            <li>
              <span className="team_info_name">
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: sport === 'tennis' ? 'player' : 'team',
                    sport,
                    name: match?.competitors?.htn,
                    id: match?.competitors?.htid,
                  })}
                  className="team_name"
                >
                  <div className="flag">
                    <NextImage
                      src={imageUrl}
                      height={30}
                      width={30}
                      alt="homeLogo"
                      priority={false}
                    />
                  </div>
                  <span className="name">{match?.competitors?.htn}</span>
                </a>
                {/* </NextLink> */}

                {match?.bs === "Live" &&
                  (match?.batid === match?.competitors?.htid ? (
                    <Icon
                      type="bat"
                      src={`${baseURL}/assets/images/Bat1.png`}
                      width={15}
                      height={14}
                      alt="bat"
                    />
                  ) : (
                    <Icon
                      type="ball"
                      src={`${baseURL}/assets/images/cricket_Ball.png`}
                      width={14}
                      height={14}
                      alt="ball"
                    />
                  ))}
              </span>

              <span className="team_info_score">
                {match?.ho ? (
                  <span className="over">{match?.ho} Ov </span>
                ) : null}

                {match?.hs}
              </span>
            </li>
            <li>
              <span className="team_info_name">
                <a
                  href={teamLeagueInfoUrl({
                    dataClient,
                    websiteBaseUrl,
                    dataPath,
                    category: sport === 'tennis' ? 'player' : 'team',
                    sport,
                    name: match?.competitors?.atn,
                    id: match?.competitors?.atid,
                  })}
                  className="team_name"

                >
                  <div className="flag">
                    <NextImage
                      src={awayImage}
                      height={30}
                      width={30}
                      alt="awayLogo"
                      priority={false}
                    />
                  </div>
                  <span className="name">{match?.competitors?.atn}</span>
                  {/* </NextLink> */}
                </a>
                {match?.bs === "Live" &&
                  (match?.batid === match?.competitors?.atid ? (
                    <Icon
                      type="bat"
                      src={`${baseURL}/assets/images/Bat1.png`}
                      width={15}
                      height={14}
                      alt="bat"
                    />
                  ) : (
                    <Icon
                      type="ball"
                      src={`${baseURL}/assets/images/cricket_Ball.png`}
                      width={14}
                      height={14}
                      alt="ball"
                    />
                  ))}
              </span>

              <span className="team_info_score">
                {match?.ao ? (
                  <span className="over">{match?.ao} Ov </span>
                ) : null}
                {match?.as}
              </span>
            </li>
          </ul>
          {match?.bs === "Scheduled" ? (
            <CountdownTimer targetDate={match?.ldt} />
          ) : null}
        </div>

        {(match?.bs === "Live" || match?.bs === "Delayed") &&
          match?.stat !== "" ? (
          <div className="match_stats">
            <p>{match?.stat}</p>
          </div>
        ) : null}

        {match?.bs === "Finished" ? (
          <div className="detail_head_finsed">
            <div className="match_stats_finsed">
              <p>{match?.com}</p>
            </div>
            <div className="match_stats_finsed">
              <ul className="inf_mch">
                <li>
                  <i className="ico ico_calandar02"></i>
                  <span>{match?.mno}</span>
                </li>
                <li>
                  <span className="inf_mch_txt">{convertDate(match?.ldt)}</span>
                </li>
              </ul>
            </div>
          </div>
        ) : null}

        {match?.bs === "Scheduled" ? (
          <div className="detail_head_finsed detail_head_upcomming">
            <div className="match_stats_finsed ">
              <ul className="inf_mch">
                <li>
                  <i className="ico ico_calandar02"></i>
                  <span>{match?.mno}</span>
                </li>
                <li>
                  <span className="inf_mch_txt">{convertDate(match?.ldt)}</span>
                </li>
              </ul>
            </div>
          </div>
        ) : null}
      </div>

      {match?.bs === "Live" ? (
        match?.rr || match?.rrr || match?.lforr || match?.resb?.length ? (
          <div className="detail_head_tft">
            <ul className="runlist_inf">
              {match?.rr ? (
                <li>
                  <span>CRR:</span>
                  {match?.rr}
                </li>
              ) : null}
              {match?.rrr ? (
                <li>
                  <span>RRR:</span> {match?.rrr}
                </li>
              ) : null}
              {match?.lforr ? (
                <li>
                  <span>Last 5 ov (RR):</span> {match?.lforr}
                </li>
              ) : null}
            </ul>

            {match?.resb?.length ? (
              <ul className="ball_inf">
                {match?.resb?.map((item, index) => {
                  const isLastBallOfOver = (over) => {
                    const [, ballInOver] = over
                      ?.toString()
                      .split(".")
                      .map(Number);
                    return ballInOver === 6;
                  };
                  return (
                    <>
                      <li
                        className={`${item?.d_score === "4" || item?.d_score === "6"
                          ? "boundary"
                          : item?.d_score === "W"
                            ? "wicket"
                            : ""
                          }`}
                        key={index}
                      >
                        {item?.d_score}
                      </li>
                      {isLastBallOfOver(item?.over) && (
                        <li key={index + 100} className="change_over">
                          -
                        </li>
                      )}
                    </>
                  );
                })}
              </ul>
            ) : null}
          </div>
        ) : null
      ) : null}
    </div>
  );
};

export default CricketMatchDetailHead;

